import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import MaterialTable from 'material-table';

import UserInteractionProfile from './UserInteractionProfile';

import { formatDate } from '../../../../utils/time';

const styles = theme => ({
  displayName: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginRight: 10,
  },
});

class DataList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userProfileDialog: true,
      userData: null,
    };
  }

  closeUserProfileDialog = event => {
    this.setState({
      userProfileDialog: false,
      userData: null,
    });
  };

  openUserProfileDialog = rowData => {
    this.setState({
      userProfileDialog: true,
      userData: rowData,
    });
  };

  render() {
    let { classes, listUsersInteraction } = this.props;
    const pageSize = listUsersInteraction.length > 5 ? 5 : listUsersInteraction.length;
    return (
      <div>
        <MaterialTable
          elevation={0}
          key={pageSize}
          options={{
            pageSize: pageSize,
            toolbar: true,
            paging: true,
          }}
          columns={[
            {
              title: 'User',
              field: 'name',
              render: rowData => {
                let name = 'Anonymous user';

                if (rowData.name) {
                  name = rowData.name;
                } else if (rowData.phone) {
                  name = rowData.phone;
                }

                return (
                  <div className={classes.displayName}>
                    <Avatar className={classes.avatar} src={rowData.profile_pic}>
                      <PersonOutlineOutlinedIcon />
                    </Avatar>
                    {name}
                  </div>
                );
              },
            },
            { title: 'Language', field: 'language' },
            {
              title: 'Subscribed',
              field: 'createdAt',
              render: rowData => <div>{formatDate(rowData.createdAt)}</div>,
              type: 'date',
            },
          ]}
          data={listUsersInteraction}
          title="Users"
          onRowClick={(event, rowData) => this.openUserProfileDialog(rowData)}
        />
        {this.state.userData && (
          <UserInteractionProfile
            userData={this.state.userData}
            open={this.state.userProfileDialog}
            onClose={this.closeUserProfileDialog}
          />
        )}
      </div>
    );
  }
}

export default withStyles(styles)(DataList);
